import gql from 'graphql-tag';

export const syncMPMyProgressTracker = gql`
  mutation mpSyncMyProductTimelineProgresses {
    mpSyncMyProductTimelineProgresses {
      productProgresses {
        studentProductTimeline {
          id
          productId
          duration
          totalDuration
          startDate
          endDate
        }
        progress {
          totalDuration
          percentComplete
        }
      }
    }
  }
`;

export const migrateMPProducts = gql`
  mutation mpMigrateProducts($studentProductTimelineIds: [ID!]!) {
    mpMigrateProducts(studentProductTimelineIds: $studentProductTimelineIds) {
      statusCode
      success
      message
    }
  }
`;
